import VerticalBlog from "./VerticalBlog";

const RecentlyPosted = ({ blogs }) => {
  return (
    <div style={{display:"flex", flexWrap:"wrap", gap:"2rem", justifyContent:"space-between", marginTop:"2rem"}}>
      {blogs.length > 0 ? (
        blogs.map((blog, index) => <VerticalBlog key={index} data={blog} />)
      ) : (
        <p>Blogs Not Available</p>
      )}
    </div>
  );
};

export default RecentlyPosted;
